var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_48_place_holder",
    "data-name": "Icon/48 place holder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon_48_place_holder_style_",
    "data-name": "Icon/48 place holder (style)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "rgba(131,191,110,0.21)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_thumbs_up_light",
    "data-name": "UI icon/thumbs_up/light",
    transform: "translate(13.921 14.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M15.658,19.306H3a3,3,0,0,1-3-3v-5a3,3,0,0,1,3-3H4.8L7.342,5.127A3.01,3.01,0,0,0,8,3.254V1.8a1.791,1.791,0,0,1,2.363-1.7A4.487,4.487,0,0,1,13.37,5.088L13,7.306l4.16,0a3,3,0,0,1,2.909,3.728l-1.5,6A3,3,0,0,1,15.658,19.306ZM10,2.1V3.254A5.019,5.019,0,0,1,8.9,6.377L6,10.008v7.3h9.658a1,1,0,0,0,.97-.758l1.5-6a1,1,0,0,0-.969-1.243l-4.16,0a2,2,0,0,1-1.972-2.329l.37-2.218A2.492,2.492,0,0,0,10,2.1ZM3,10.306a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1H4v-7Z",
    fill: "#33383f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribers);
export default __webpack_public_path__ + "static/media/subscribers.ea58c920adba8d5c817e62afe44bbaf2.svg";
export { ForwardRef as ReactComponent };